import { render, staticRenderFns } from "./WPGroupMultiline.vue?vue&type=template&id=3857c601"
import script from "./WPGroupMultiline.vue?vue&type=script&lang=ts"
export * from "./WPGroupMultiline.vue?vue&type=script&lang=ts"
import style0 from "./WPGroupMultiline.vue?vue&type=style&index=0&id=3857c601&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports